import { createKsStore, type KsStoreHook } from '@siclop/kstone-vue'
import { LeaveRequest } from '../models/LeaveRequest'
import { LeaveRequestForm } from '../forms/LeaveRequestForm'
import { LeaveRequestFilter } from '../filters/LeaveRequestFilter'
import { LeaveRequestService } from '../services/LeaveRequestService'

export const useLeaveRequestStore: KsStoreHook<LeaveRequest, LeaveRequestForm, LeaveRequestFilter> = createKsStore({
  id: 'leaveRequests',
  modelClass: LeaveRequest,
  formClass: LeaveRequestForm,
  filterClass: LeaveRequestFilter,
  service: LeaveRequestService,
  labelField: (item) => `${item.leaveTypeName || 'Congé'} - ${item.startDate}`,
  signalREventName: 'LeaveRequestModel'
})
